import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import HotelIcon from '@mui/icons-material/Hotel'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'
import React from 'react'

import FlightIcon from '@/src/assets/svgs/FlightIcon'
import FlightPlusHotelIcon from '@/src/assets/svgs/FlightPlusHotelIcon'

import { ToolbarLink, ToolbarPathMap } from '@/src/types/bottomToolbar'
import { isCTAE } from '@/src/utils/generalUtils/isCTAE'
import { isFlyin } from '@/src/utils/generalUtils/isFlyin'
import LanguageIcon from '@mui/icons-material/Language'
// Note: Labels are translation keys, not actual text
// They will be translated in the component using useTranslations('common')
export const COMMON_TOOLBAR_LINKS: ToolbarLink[] = [
    {
        label: 'flight',
        value: 'flight',
        icon: React.createElement(FlightIcon),
        index: 0,
    },
    {
        label: 'hotel',
        value: 'hotel',
        icon: React.createElement(HotelIcon),
        index: 1,
    },

    {
        label: 'offers',
        value: 'offers',
        icon: React.createElement(LocalOfferOutlinedIcon),
        index: 3,
    },
    {
        label: 'account',
        value: 'account',
        icon: React.createElement(AccountCircleOutlinedIcon),
        index: 4,
    }
]

export const FLYIN_TOOLBAR_LINKS: ToolbarLink[] = [
    {
        label: 'flightPlusHotel',
        value: 'fph',
        icon: React.createElement(FlightPlusHotelIcon),
        index: 2,
    },
]

export const CT_TOOLBAR_LINKS: ToolbarLink[] = [
    {
        label: 'visa',
        value: 'visa',
        icon: React.createElement(LanguageIcon),
        index: 2
    }
]

export const TOOLBAR_PATH_MAP: ToolbarPathMap = {
    flight: '/',
    hotel: '/hotels',
    fph: '/fph',
    offers: '/offers',
    account: '/account',
    visa: '/visa',
}

// Function to get the appropriate toolbar links based on the brand.
// Uses brand check (isFlyin) rather than feature flags—FPH and Visa are brand-specific offerings.
interface ToolbarLinkOptions {
    showVisa?: boolean
    showFlightsHotels?: boolean
    showOffers?: boolean
}

export const fetchToolbarLinks = (options?: ToolbarLinkOptions): ToolbarLink[] => {
    const { showVisa = false, showFlightsHotels = false, showOffers = true } = options || {}
    let links: ToolbarLink[] = COMMON_TOOLBAR_LINKS.filter(link => showOffers || link.value !== 'offers')
    if (isFlyin()) {
        if (showVisa && !showFlightsHotels) {
            links = links.concat(CT_TOOLBAR_LINKS)
        }

        else {
            if (showFlightsHotels)
                links = links.concat(FLYIN_TOOLBAR_LINKS)
        }
        // TEMPORARILY DISABLED: Visa hidden everywhere. Restore `else if (isCTAE())` (unconditional) to re-enable.
    } else if (isCTAE() && showVisa) {
        links = links.concat(CT_TOOLBAR_LINKS)
    }
    links.sort((a, b) => (a.index ?? links.length - 1) - (b.index ?? links.length - 1))
    return links
}
